import { createFileRoute } from '@tanstack/react-router'

import { RouteModal } from '@/components/route-modal'
import { CatalogUnitForm } from '@/routes/_authenticated/settings/units-of-measure/-catalog-form'

export const Route = createFileRoute('/_authenticated/settings/units-of-measure/create')({
	component: RouteComponent,
	staticData: {
		crumb: ({ context: { L } }) => L.Settings.UnitsOfMeasure.CreateTitle()
	}
})

function RouteComponent() {
	return (
		<RouteModal asDrawer>
			<CatalogUnitForm />
		</RouteModal>
	)
}
